// extracted by mini-css-extract-plugin
export var bg = "MultiBrandSection-module--bg--iPy-3";
export var bxTextTruncateEnd = "MultiBrandSection-module--bx--text-truncate--end--ItbyI";
export var bxTextTruncateFront = "MultiBrandSection-module--bx--text-truncate--front--fRQ3M";
export var containerSelect = "MultiBrandSection-module--containerSelect--e3Vgn";
export var description = "MultiBrandSection-module--description--9WAAW";
export var flex = "MultiBrandSection-module--flex--l4ak8";
export var itemsCenter = "MultiBrandSection-module--items-center--PEG-G";
export var justifyBetween = "MultiBrandSection-module--justify-between--+2260";
export var maxWidthFull = "MultiBrandSection-module--max-width-full--+R2m5";
export var mb2 = "MultiBrandSection-module--mb-2--d+yQc";
export var my8 = "MultiBrandSection-module--my-8--4uQVr";
export var row1 = "MultiBrandSection-module--row1--G+oO8";
export var title = "MultiBrandSection-module--title--aznH9";